function guaranteeCardsReducer(state = { cardsStatus: '' }, action) {
    switch (action.type) {
        case "GET_CARD_STATUS":
            return {
                ...state,
                cardsStatus: action.data
            };
            default:
                return state;
    }

}
export default guaranteeCardsReducer;